<template>
  <div class="cpt-sku-item">
    <div class="cover-wrapper" @click="toDetail">
      <img class="sku-cover" v-src="sku.head_image">
      <!-- <div 
        class="remain-count" 
        :class="{ 'active': canBuy }"
        :style="{ 'background': canBuy ? gradientStyle.tagBg : ''}"
        v-if="tagDesc"
      >
        <p v-if="sku.sale.left_percent != 0">{{ tagDesc }}</p>
        <p v-else>已售罄</p>
      </div> -->
    </div>
    <div class="info-wrapper">
      <div class="game-name" :style="{ color: cc.game_name_color }" @click="toDetail">{{ sku.name }}</div>
      <div class="hb-discont" v-if="sku.hcoin_percent" :style="{ background: gradientStyle.tagBg }">H币可抵{{ sku.hcoin_percent }}%</div>
      <div class="hb-discount-placeholder" v-else></div>
      <div 
        class="price-wrapper"
        :style="{ background: isOutdated ? calcGradientBg(cc.price_area_end_bg) : calcGradientBg(cc.price_area_active_bg)}"
      >
        <div class="price-info-wrapper">
          <div class="price-value">
            <div class="new-price" :style="{ color: cc.price_highlight_color }">
              <div class="unit">￥</div>
              <div class="value">{{ sku.price.final_price | formatHcoin }}</div>
            </div>
            <div class="old-price" :style="{ color: cc.price_normal_color }">
              <div class="unit">￥</div>
              <div class="value">{{ sku.price.initial_price | formatHcoin }}</div>
            </div>
          </div>
          <div class="discount-info" :style="{ color: cc.price_highlight_color }">-{{sku.price.discount | formatDiscount}}%</div>
        </div>
        <div 
          class="buy-wrapper" 
          :class="{'active': canBuy, 'outdate': isOutdated}"
          @click="skuOp"
          :style="{ 'background': canBuy ? gradientStyle.opBtnHighlightBg : isOutdated ? gradientStyle.opBtnBannedBg : gradientStyle.opBtnNormalBg}"
        >
          <svg class="flash-icon" width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6764 0H3.41115C2.92558 0 2.51025 0.347227 2.42658 0.82313L0.0152177 14.5395C-0.0917619 15.148 0.378896 15.7053 0.999782 15.7053H3.75031C4.39902 15.7053 4.87586 16.3106 4.72087 16.9374L1.30204 30.763C1.03056 31.8609 2.5178 32.4865 3.12014 31.5278L14.8464 12.8643C15.2626 12.202 14.784 11.3427 13.9989 11.3427H9.27081C8.5723 11.3427 8.08921 10.648 8.33548 9.99762L11.6118 1.34509C11.858 0.694716 11.375 0 10.6764 0Z" :fill="isOutdated ? cc.flash_end_color : cc.flash_highlight_color"/>
          </svg>
          <div class="buy-desc" :style="{ color: cc.op_text_color }">{{ skuOpDesc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { executeProtocol, getUrlParam, showMessage } from '_lib/utils'
export default {
  props: {
    curTime: {
      type: Number,
      default: 0
    },
    sku: {
      type: Object,
      default: () => {},
    },
    cc: {
      type: Object,
      default: () => {},
    },
    gradientStyle: {
      type: Object,
      default: () => {},
    }
  },
  computed: {
    canBuy() {
      return this.skuState == 1
    },
    isOutdated() {
      return this.skuState == 2
    },
    skuState() {
      return this.sku?.sale.state
    },
    skuOpDesc() {
      switch(this.skuState) {
        case 0: 
          return '未开始'
        case 1:
          return '马上抢'
        case 2:
          return '已结束'
        case 3:
          return '已购买'
        default: 
          return '去看看'
      }
    },
    // tagDesc() {
    //   switch(this.skuState) {
    //     case 0: 
    //       return '未开始'
    //     case 1:
    //       return `剩余${parseInt(this.sku.sale.left_percent)}%`
    //     case 2:
    //       return '已结束'
    //     case 3:
    //       return '已购买'
    //     default: 
    //       return ``
    //   }
    // }

  },

  methods: {
    skuOp() {
      let isShare = getUrlParam('is_share')
      if (isShare) {
        window.location.href = window.location.origin + '/open_inapp/#heybox://'
        return
      } else {
        switch (this.skuState) {
          case 1:
            this.toDetail()
            break;
          default:
            break;
        }
      }
    },
    toDetail() {
      let params = {
        protocol_type: "openGameDetail",
        app_id: this.sku.game_info.appid,
        game_type: this.sku.game_info.game_type
      }
      if (this.sku?.sku_id) {
        params.sku_id = this.sku.sku_id.toString()
      }
      executeProtocol(params)
    },
    toBuy() {
      this.$emit('purchase', this.sku)
    },
    calcGradientBg(str) {
      if(!str) {
        return ''
      }
      const colors = str.split(',')
      switch(colors.length) {
        case 1: 
          return colors[0]
        case 2: 
          return `linear-gradient(to right, ${colors[0]} 0%, ${colors[1]} 100%)`
        default:
          return str
      }
    }
  },
  filters: {
    formatDiscount(v) {
      return Math.floor(100 - Number(v) * 100)
    },
    formatHcoin (hcoin) {
      return Math.ceil(parseFloat((hcoin / 1000).toFixed(2)))
    },
  }
};
</script>

<style lang="less" scoped>
.cpt-sku-item {
  height: 90px;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .cover-wrapper {
    width: 158px;
    height: 90px;
    margin-right: 8px;
    border-radius: 3px;
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    .sku-cover {
      width: 100%;
      height: 100%;
    }
    .remain-count {
      padding: 1px 4px;
      line-height: 14px;
      font-size: 10px;
      font-weight: 500;
      color: #FFF;
      transform: scale(0.9);
      transform-origin: bottom left;
      position: absolute;
      bottom: 0px;
      left: 0px;
      border-radius: 0 3px 3px 3px;
      background: linear-gradient(to right, #404040 0%, #2E2E2E 100%);
      &.active {
        background: #FF7801;
      }
    }
  }
  .info-wrapper {
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .game-name {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #FFF;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .hb-discont {
      width: fit-content;
      margin-top: 2px;
      background: #FF6A02;
      padding: 1px 4px;
      font-size: 10px;
      line-height: 14px;
      color: #FFF;
      border-radius: 2px;
      transform: scale(0.9);
      transform-origin: top left;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 200%;
        height: 200%;
        border-radius: 4px;
        border: 1px solid #FF6502;
        transform: scale(0.5);
        transform-origin: top left;
        box-sizing: border-box;
      }
    }
    .hb-discount-placeholder {
      width: fit-content;
      margin-top: 2px;
      height: 16px;
      transform: scale(0.9);
    }
    .price-wrapper {
      width: 100%;
      height: 32px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
      margin-top: 14px;
      display: flex;
      flex-direction: row;
      overflow: hidden;
      .price-info-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 1;
        padding: 6px 12px 6px 6px;
        .price-value {
          display: flex;
          flex-direction: row;
          align-items: baseline;
          justify-content: center;
          .new-price {
            display: flex;
            flex-direction: row;
            align-items: baseline;
            justify-content: center;
            color: #FF6502;
            .unit {
              width: 12px;
              font-size: 12px;
              line-height: 16px;
              font-weight: 600;
            }
            .value {
              font-size: 17px;
              line-height: 20px;
            }
          }
          .old-price {
            display: flex;
            flex-direction: row;
            align-items: baseline;
            justify-content: center;
            color: rgba(255, 255, 255, 0.4);
            .unit {
              font-size: 10px;
              line-height: 15px; 
              text-decoration: line-through;
            }
            .value {
              font-size: 10px;
              line-height: 12px;
              text-decoration: line-through;
            }
          }
        }
        .discount-info {
          margin-left: 4px;
          padding: 1px 4px;
          color: #FF6502;
          font-size: 11px;
          line-height: 13px;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 0px;
            left: 0px;
            width: 200%;
            height: 200%;
            border-radius: 4px;
            border: 1px solid #FF6502;
            transform: scale(0.5);
            transform-origin: top left;
          }
        }
      }
      .buy-wrapper {
        width: 63px;
        flex-shrink: 0;
        position: relative;
        background: rgba(255, 120, 1, 0.5);

        &.outdate {
          background: linear-gradient(to right, #9B9B9B 0%, #8B8B8B 100%);
        }
        &.active {
          background: linear-gradient(to right, #FF7801 0%, #FF5E01 100%);
        }
        .flash-icon {
          position: absolute;
          height: 32px;
          top: 0px;
          left: -4px;
        }
        .buy-desc {
          color: #FFF;
          font-weight: 500;
          line-height: 16px;
          font-size: 12px;
          position: absolute;
          top: 8px;
          right: 10px;
        }
      }
    }
  }
}
</style>